import { IUserSelection } from 'state/product-wizard-v2/types';
import { ProductWizardUtils } from 'state/product-wizard-v2/utils';

export const getNextComboSlotKey = ({
  slotKeyToCustomize,
  userSelections,
}: {
  slotKeyToCustomize: string;
  userSelections: IUserSelection;
}) => {
  const comboSlotKeys = userSelections.comboSlot ? Array.from(userSelections.comboSlot.keys()) : [];
  const currentIndex = comboSlotKeys.indexOf(slotKeyToCustomize);
  return currentIndex < comboSlotKeys.length - 1 ? comboSlotKeys[currentIndex + 1] : null;
};

export const findNextValidComboSlotKey = (
  nextComboSlotKey: string | null,
  userSelections: IUserSelection
): string | null => {
  if (!nextComboSlotKey || !userSelections.comboSlot) {
    return null;
  }

  // Validate the next combo slot key
  const nextComboSlot = userSelections.comboSlot?.get(nextComboSlotKey);
  const nextItemToCustomize = nextComboSlot?.selectedItem ?? null;

  const isCustomizableItem =
    !!nextItemToCustomize && ProductWizardUtils.IsCustomizable(nextItemToCustomize);

  const isCustomizableComboSlot =
    !!nextComboSlot?.comboSlot && ProductWizardUtils.IsCustomizable(nextComboSlot.comboSlot);

  const isValid = isCustomizableItem || isCustomizableComboSlot;

  if (isValid) {
    return nextComboSlotKey;
  }

  const nextComboSlotKeyToValidate = getNextComboSlotKey({
    slotKeyToCustomize: nextComboSlotKey,
    userSelections,
  });

  return findNextValidComboSlotKey(nextComboSlotKeyToValidate, userSelections);
};
